import Close from '@mui/icons-material/Close';
import { Button, Dialog, DialogTitle, Typography } from '@mui/material';
import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import PainelDetalhes from './PainelDetalhes';

class ModalDetalhesProcesso extends ReactComponent {
    handleCloseModalProcesso = () => {
        this.store.processoModal = undefined;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleCloseModalProcesso: action
        });
    }

    render() {
        if (!this.store.processoModal) {
            return null;
        }

        return (
            <Dialog
                fullWidth
                maxWidth="xl"
                PaperProps={{ style: { height: '100%' } }}
                onClose={this.handleCloseModalProcesso}
                open={this.store.processoModal !== undefined}
            >
                <DialogTitle style={{ padding: '8px 12px 5px' }}>
                    <div>
                        <Typography
                            color="secondary"
                            variant="h6"
                        >
                            Processo está na sessão, mas não corresponde aos critérios de filtro
                        </Typography>
                        <Button
                            color="secondary"
                            style={{ position: 'absolute', top: '0px', right: '0px', minWidth: '24px' }}
                            onClick={this.handleCloseModalProcesso}
                        >
                            <Close />
                        </Button>
                    </div>
                </DialogTitle>
                <PainelDetalhes />
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ModalDetalhesProcesso));
